// Preview addresses follow one convention: preview-<name>.<domain>. See docs/PREVIEW_ENVIRONMENTS.html.
export const isPreviewHost = (hostname: string): boolean => hostname.startsWith("preview-");

export const isTrackingHost = (hostname: string): boolean =>
  hostname === "q.queueryte.com" || hostname === "staging-q.queueryte.com" || hostname === "preview-q.queueryte.com";
